import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';
import bulkOrderModule from "@/store/modules/bulkOrder.store";
import filterModule from "@/store/modules/filter.store";
import identityModule from "@/store/modules/identity.store";
import shoppingCartModule from "@/store/modules/shoppingCart.store";
import snackbarModule from "@/store/modules/snackbar.store";
import warehouseModule from "@/store/modules/warehouse.store";
import editOrderModule from "@/store/modules/editOrder.store";
import editBulkOrderModule from "@/store/modules/editBulkOrder.store";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
    key: 'hamster',
    storage: window.localStorage
});

export default new Vuex.Store({
    plugins: [vuexPersist.plugin],
    modules: {
        bulkOrder: bulkOrderModule,
        filter: filterModule,
        identity: identityModule,
        shoppingCart: shoppingCartModule,
        snackbar: snackbarModule,
        warehouse: warehouseModule,
        editOrder: editOrderModule,
        editBulkOrder: editBulkOrderModule
    }
});
